import { GameCategory, SlateGroupScope } from '../enums';

export const specialMarketNames = new Set(['Yes', 'Even']);

export const GeneralOddsQueueJobSettings = {
	removeOnComplete: 100,
	removeOnFail: 100,
	stackTraceLimit: 100,
	attempts: 1,
	backoff: {
		type: 'exponential',
		delay: 1000,
	},
};

export const slateGroupScopes: Record<string, SlateGroupScope> = {
	[GameCategory.NBA]: SlateGroupScope.BY_MONTH,
	[GameCategory.NCAAB]: SlateGroupScope.BY_DAY,
	[GameCategory.NFL]: SlateGroupScope.BY_WEEK,
	[GameCategory.MLB]: SlateGroupScope.BY_DAY,
	[GameCategory.EPL]: SlateGroupScope.BY_WEEK,
	[GameCategory.UCL]: SlateGroupScope.BY_DAY,
	[GameCategory.FIFA]: SlateGroupScope.BY_DAY,
	[GameCategory.NHL]: SlateGroupScope.BY_DAY,
	[GameCategory.PGA]: SlateGroupScope.BY_DAY,
	[GameCategory.ATP]: SlateGroupScope.BY_DAY,
	[GameCategory.WTA]: SlateGroupScope.BY_DAY,
	[GameCategory.TENNIS]: SlateGroupScope.BY_DAY,
	[GameCategory.NCAAF]: SlateGroupScope.BY_WEEK,
};

export const sportsbookPriority = ['FanDuel', 'Fanatics'];

export const sportsbookPriorityMap = new Map<string, number>(
	sportsbookPriority.map((s, i) => [s, i])
);

export const regexMarketCreation = new RegExp(`\\b(${['No', 'Odd', 'Under'].join('|')})\\b`, 'i');
